import React from 'react';
import { Chip } from '@mui/material';
import { statusLook } from '../../utils/pettyCash';

/** A claim's status as the server shows it (displayStatus: a posted claim paid back reads Reimbursed). */
export const ClaimStatusChip: React.FC<{ status: string }> = ({ status }) => {
  const s = statusLook(status);
  return <Chip size="small" color={s.color} label={s.label} />;
};

/** Statuses in which the holder waits for finance to pay the claim back. */
export const WAITING_STATUSES = ['FinanceReview', 'Posting', 'Posted', 'PartiallyPosted'];

/**
 * Working days since the claim reached finance: "Waiting 5 working days (target 7)", in the warning colour once
 * overdue; "Reimbursed after 4 working days" once paid back. Nothing before finance.
 */
export const WaitingChip: React.FC<{ days: number | null | undefined; target?: number | null; overdue?: boolean; reimbursed?: boolean }> = ({
  days, target, overdue, reimbursed,
}) => {
  if (days === null || days === undefined) return null;
  const n = `${days} working day${days === 1 ? '' : 's'}`;
  const of = target ? ` (target ${target})` : '';
  if (reimbursed) return <Chip size="small" variant="outlined" label={`Reimbursed after ${n}${of}`} />;
  return (
    <Chip
      size="small"
      variant={overdue ? 'filled' : 'outlined'}
      color={overdue ? 'warning' : 'default'}
      label={overdue ? `Overdue: waiting ${n}${of}` : `Waiting ${n}${of}`}
    />
  );
};
